import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=fdfc9868&scoped=true"
import script from "./Transactions.vue?vue&type=script&lang=js"
export * from "./Transactions.vue?vue&type=script&lang=js"
import style0 from "./Transactions.vue?vue&type=style&index=0&id=fdfc9868&prod&lang=scss&scoped=true"
import style1 from "./Transactions.vue?vue&type=style&index=1&id=fdfc9868&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfc9868",
  null
  
)

export default component.exports